module.exports = __webpack_public_path__ + "img/img7.5759541a.png";